<template>
  <v-row justify="center">
    <v-card class="transparent my-3 mx-auto" rounded outlined width="900">
      <v-card-text style="height: calc(100vh - 175px); overflow-y: auto;">
        <div class="d-flex align-center mb-6">
          <img class="mt-n2" :src="require('@/assets/appLogo-color--Onlight.svg')" width="100"/>
        </div>

        <span class="text-h5 font-weight-medium">Sobre ti</span>
        <span class="ml-3 body-1 text--primary">Ayúdanos a personalizar tu experiencia en Piriod.</span>

        <span class="d-block mt-6 mb-3 body-1 font-weight-medium">¿Qué describe mejor el trabajo que haces?</span>
        <v-row class="px-1">
          <v-col cols="3" v-for="(option, i) in roles" :key="`role-${i}`">
            <v-hover v-slot:default="{ hover }">
              <v-sheet class="pa-4 text-center cursor-pointer" :class="{ 'v-sheet--active': responses.role === option.id }" @click="setResponse('role', option.id)" outlined rounded="lg" width="100%" :elevation="hover ? '3' : '0'">
                <v-avatar color="indigo lighten-5" size="32"><v-icon color="primary">{{ option.icon }}</v-icon></v-avatar>
                <span class="d-block mt-3 text--secondary font-weight-medium">{{ option.label }}</span>
              </v-sheet>
            </v-hover>
          </v-col>
        </v-row>

        <span class="d-block mt-6 mb-3 body-1 font-weight-medium">¿Cómo supiste de Piriod?</span>
        <template v-for="(d, i) in channels">
          <v-checkbox class="d-inline-block my-2 mx-4 ml-0 outlined" :key="`ch-${i}`" v-model="selectedChannels" color="primary" hide-details :label="d.label" :ripple="false" :value="d.id" />
        </template>
      </v-card-text>

      <v-card-actions class="pa-10">
        <v-spacer/>
        <span class="mr-6 red--text" v-if="showError">{{ errorMessage }}</span>
        <v-btn class="pr-3 pl-6" @click="submit" color="primary" large :loading="loading" :ripple="false">
          Continuar<v-icon dark right size="22">mdi-arrow-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import { roles, channels } from '@/collections/onboarding'

export default {
  mixins: [GenericViewMixin],
  data: () => ({
    roles,
    channels,
    selectedChannels: [],
    showError: false,
    errorMessage: '',
    loading: false
  }),
  computed: {
    ...mapState({
      responses: state => state.onboarding.responses
    })
  },
  created () {
    this.$store.dispatch('auth/RETRIEVE_TRACE')

    this.$store.dispatch('onboarding/LOAD_USER_PROFILE').then(() => {
      if (this.responses.role && this.responses.channels.length) {
        const target = this.$store.state.auth.account.id ? 'OrganizationOnboarding' : 'OrganizationCreate'
        this.$router.push({ name: target })
        return
      }

      if (this.responses.channels && this.responses.channels.length) {
        this.selectedChannels = [...this.responses.channels]
      }
    })
  },
  methods: {
    setResponse (key, value) {
      this.showError = false
      this.$store.dispatch('onboarding/SET_RESPONSE', { key, value })
    },
    submit () {
      if (!this.responses.role) {
        this.showError = true
        this.errorMessage = 'Selecciona tu rol.'
        return
      }
      if (!this.selectedChannels.length) {
        this.showError = true
        this.errorMessage = 'Selecciona al menos un canal.'
        return
      }

      this.loading = true
      this.setResponse('channels', this.selectedChannels)
      this.$store.dispatch('onboarding/SAVE_USER_PROFILE')
        .then(() => {
          this.trackEvent('Onboarding Step Completed', { step: 'about_you', answer: this.responses.role })
          const target = this.$store.state.auth.account.id ? 'OrganizationOnboarding' : 'OrganizationCreate'
          this.$router.push({ name: target })
        })
        .catch(() => {
          this.showError = true
          this.errorMessage = 'Error al guardar tu perfil.'
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.v-sheet--outlined.v-sheet--active {
  border: 1px solid #3F51B5 !important;
}

.v-application .elevation-0.v-sheet--active,
.v-application .elevation-3:hover.v-sheet--active {
  box-shadow: 0px 0px 0px 3px #CCE1FF !important;
}
</style>

<style>
.v-input--checkbox.outlined {
  border: 1px solid #D9E0EA;
  border-radius: 12px;
  padding: 0 !important;
}
.v-input--checkbox.outlined .v-input__slot {
  padding: 12px 16px;
}
</style>
